// components/Toast.js
import React from 'react';
import { motion } from "framer-motion";

const Toast = ({ message, type, position, backgroundColor, buttonText, buttonAction }) => {
    // Determine background color based on type or use provided backgroundColor
    const toastColor = backgroundColor || (type === 'success' ? 'green' : 'red');

    // Determine position styles based on position prop
    let positionStyles = '';
    switch (position) {
        case 'top':
            positionStyles = 'top-20 left-1/2 transform -translate-x-1/2';
            break;
        case 'bottom':
            positionStyles = 'bottom-20 left-1/2 transform -translate-x-1/2';
            break;
        case 'topLeft':
            positionStyles = 'top-20 left-20';
            break;
        case 'topRight':
            positionStyles = 'top-60 right-16';
            break;
        case 'bottomLeft':
            positionStyles = 'bottom-20 left-20';
            break;
        case 'bottomRight':
            positionStyles = 'bottom-20 right-20';
            break;
        case 'topCenter':
            positionStyles = 'top-20 left-1/2 transform translate-x-1';
            break;
        case 'bottomCenter':
            positionStyles = 'bottom-40 left-[15%]';
            break;
        default:
            positionStyles = 'top-20 right-20'; // Default to top-right if position is not specified
            break;
    }
    
    console.log('buttonText', buttonText);
    console.log('message', message);
    console.log('backgroundColor', backgroundColor);
    console.log('toastColor', toastColor);

    const toastVariants = {
        hidden: { opacity: 0, y: -20 },
        visible: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: 20 }
    };

    return (
        <motion.div className={`flex items-center p-4 py-3 text-xs rounded-lg max-sm:w-[70%] shadow-lg text-white ${toastColor} fixed ${positionStyles} z-50`} 
        style={{ backgroundColor: `${backgroundColor}8A` }}
        initial="hidden"
        animate="visible"
        exit="exit"
        variants={toastVariants}
        transition={{ duration: 0.5 }}
        >
            <div>{message}</div>
            {buttonText && (
                <button
                    className="pl-4 text-pink-800 font-semibold rounded-md cursor-pointer"
                    onClick={buttonAction}
                >
                    {buttonText}
                </button>
            )}
        </motion.div>
    );
};

export default Toast;
